import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Topic } from 'src/app/_models/topic';
import { TopicService } from 'src/app/_services/topic.service';
import Swal from 'sweetalert2';
declare var $ : any;
@Component({
  selector: 'app-admin-syllabus-topic-show',
  templateUrl: './admin-syllabus-topic-show.component.html',
  styleUrls: ['./admin-syllabus-topic-show.component.css']
})
export class AdminSyllabusTopicShowComponent implements OnInit {
  topic =  new Topic()
  topic_id=0
  loading=true
  constructor(
    private route:ActivatedRoute,
    private topicService:TopicService,
    private router:Router
    ) { }

  ngOnInit(): void {
    this.loading=true
    this.route.params.subscribe(
      params=>{
        this.topic_id=params['server_topic_id']
        if(this.topic_id!=0){
          this.topicService.getTopicById(this.topic_id).subscribe(
            x=>{
              this.topic=x
              this.loading=false

            }
          )
        }
      }
    )

  }
  reloadTopic(){
    this.loading=true
    this.topicService.getTopicById(this.topic_id).subscribe(
      xx=>{
        this.topic=xx
        this.loading=false
      }
    )
  }
  addSubTopicPopUp(){
    $("#addSubTopicModal").modal("show");
  }
  deleteTopic(){
    this.topicService.deleteTopic(this.topic.server_topic_id).subscribe(
      xx=>{
        if(xx!=0){
          Swal.fire('Deleted!', '', 'success')
          this.router.navigate(['admin/syllabus/show',xx]);
        }else{
          Swal.fire('Failed. Topic has sup Topics', '', 'info')
        }

      }
    )
  }
  editTopicPopUp(){
    $("#editTopicModal").modal("show");
  }

  showDeleteAlert(){
    Swal.fire({
      title: 'Do you want to Delete the Topic?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Delete?',
      denyButtonText: `Don't save`,
    }).then((result) => {

      if (result.isConfirmed) {
        this.deleteTopic()
      } else if (result.isDenied) {
        Swal.fire('Changes are not saved', '', 'info')
      }
    })

}
}


